import React from 'react'
import PropTypes from 'prop-types'
import { getCategories } from 'SRC/modules/categories/selectors'
import { getCountries } from 'SRC/modules/geoObjects/countries/selectors'
import { connect } from 'react-redux'
import { CitiesApi } from 'SRC/modules/geoObjects/cities/api'
import { LocationsApi } from 'SRC/modules/geoObjects/locations/api'
import { reduxForm, change, Form } from 'redux-form'
import { compose } from 'recompose'
import { Select, TextInput } from 'SRC/ui/FormElements'
import Router from 'next/router'
import { setQuery, setLastChangedField, setLoading } from '../../../actions'
import { getQuery, getLoading, getUserType, getLastChangedField, getJobFieldSpecification } from '../../../selectors'
import { getCitiesByCountryWithinRegions } from 'SRC/modules/geoObjects/cities/selectors'
import { getLocations } from 'SRC/modules/geoObjects/locations/selectors'
import { getServices } from 'SRC/modules/ads/services/selectors'
import { getServiceTypes } from 'SRC/modules/ads/serviceTypes/selectors'
import { ServiceTypesApi } from 'SRC/modules/ads/serviceTypes/api'
import config from 'SRC/config/config.yaml'

export class FilterForm extends React.PureComponent {
  static defaultProps = {
    categories: [],
    countries: [],
    cities: [],
    locations: [],
    isLoading: false
  }

  static propTypes = {
    categories: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number.isRequired,
      title: PropTypes.string.isRequired
    })).isRequired,
    countries: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number.isRequired,
      label: PropTypes.string.isRequired
    })).isRequired,
    cities: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number.isRequired,
      label: PropTypes.string.isRequired,
      region: PropTypes.number.isRequired
    })).isRequired,
    locations: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number.isRequired,
      label: PropTypes.string.isRequired
    })).isRequired,
    initialValues: PropTypes.object.isRequired,
    change: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    baseAs: PropTypes.string.isRequired,
    setQuery: PropTypes.func.isRequired,
    isLoading: PropTypes.bool.isRequired,
    placeholder: PropTypes.string,
    userType: PropTypes.shape({
      seo: PropTypes.string.isRequired,
      children: PropTypes.array
    }),
    services: PropTypes.array.isRequired,
    serviceTypes: PropTypes.array.isRequired,
    setLastChangedField: PropTypes.func.isRequired,
    lastChangedField: PropTypes.string,
    jobFieldSpecification: PropTypes.object,
    setLoading: PropTypes.func.isRequired
  }

  static formName = 'users-filter'

  constructor (props) {
    super(props)

    const { initialValues, cities } = props

    console.log('initialvalues', initialValues)

    let initialCities = []

    if (initialValues.country && cities && Array.isArray(cities[initialValues.country])) {
      initialCities = this.prepareCities(cities[initialValues.country])
    }

    this.state = {
      cities: initialCities,
      isCitiesLoading: false,
      locations: this.prepareLocations(this.props.locations),
      isLocationsLoading: false,
      serviceTypes: this.prepareServiceTypes(this.props.serviceTypes),
      isServiceTypesLoading: false
    }

    if (Router.router) {
      Router.router.events.on('routeChangeStart', this.saveScrollY)
      Router.router.events.on('routeChangeComplete', this.scrollToSavedScroll)
    }

    this.scrollY = null
  }

  saveScrollY = () => {
    this.scrollY = window.scrollY
  }

  scrollToSavedScroll = () => {
    window.scrollTo(window.scrollX, this.scrollY)
  }

  getCategoryField = () => ({
    id: 'parentCategory',
    name: 'parentCategory',
    options: this.prepareCategories(),
    labelDefault: 'Izaberi kategoriju',
    className: 'users-list__select',
    needColon: false,
    disabled: this.props.isLoading
  })

  getUserTypeField = () => {
    return {
      id: 'userType',
      name: 'djelatnost',
      options: this.prepareUserTypes(),
      labelDefault: 'Izaberi djelatnost',
      className: 'users-list__select',
      needColon: false,
      disabled: this.props.isLoading
    }
  }

  getCountryField = () => ({
    id: 'country',
    name: 'country',
    options: this.prepareCountries(),
    onChange: this.onCountryChange,
    labelDefault: 'Izaberi državu',
    className: 'users-list__select',
    needColon: false,
    disabled: this.props.isLoading
  })

  getCityField = () => ({
    id: 'city',
    name: 'city',
    options: this.state.cities,
    onChange: this.onCityChange,
    disabled: this.state.isCitiesLoading || this.props.isLoading,
    labelDefault: 'Izaberi grad',
    className: 'users-list__select',
    needColon: false
  })

  getLocationField = () => ({
    id: 'locations',
    name: 'location',
    options: this.state.locations,
    disabled: this.state.isLocationsLoading || this.props.isLoading,
    labelDefault: 'Izaberi lokaciju',
    className: 'users-list__select users-list__select_last',
    needColon: false
  })

  getSearchField = () => ({
    id: 'fullText',
    name: 'fullText',
    placeholder: this.props.placeholder,
    wrapperClass: `users-list__search ${this.isServiceProvider() ? 'users-list__search_short' : ''}`,
    needColon: false,
    isBlocked: this.props.isLoading
  })

  getJobField = () => {
    const { jobFieldSpecification, isLoading } = this.props

    const specification = jobFieldSpecification.specification

    return {
      id: 'oblastZaposlenja',
      name: 'specifications',
      options: specification.options.map(option => ({
        id: `${specification.id}_${option}`,
        label: option,
        value: '[{"id":' + specification.id + ',"value":' + `"${option}"` + '}]',
        isGrouped: false,
        options: []
      })),
      disabled: isLoading,
      labelDefault: jobFieldSpecification.specification.title,
      className: 'users-list__select',
      needColon: false
    }
  }

  prepareCategories = () => {
    const { categories } = this.props

    const excludeParentCategories = config.userTypes.usersFilter['web-prodavnica'].excludeParentCategories || []
    const renameParentCategories = config.userTypes.usersFilter['web-prodavnica'].renameParentCategories || {}

    const filteredCategories = categories.filter(c => !excludeParentCategories.includes(c.title))

    if (Array.isArray(categories)) {
      return filteredCategories.map(category => ({
        id: category.id,
        label: renameParentCategories[category.title] || category.title,
        isGrouped: false,
        value: category.id,
        options: []
      }))
    }

    return []
  }

  prepareUserTypes = () => {
    const { userType } = this.props

    console.log('userType', userType)

    if (userType && Array.isArray(userType.children)) {
      return userType.children.map(ut => ({
        id: ut.id,
        label: ut.name,
        value: ut.id,
        isGrouped: false,
        options: []
      }))
    }

    return []
  }

  prepareCountries = () => this.props.countries.filter(country => !country.parent).map(country => {
    const isGrouped = Boolean(this.props.countries.filter(item => item.parent === country.id).length)
    return {
      id: country.id,
      label: country.label,
      isGrouped,
      isDisabled: false,
      value: country.id,
      options: isGrouped ? this.props.countries.filter(item => item.parent === country.id).map(item => ({
        value: item.id,
        isDisabled: false,
        label: item.label
      })) : null
    }
  })

  onCountryChange = async e => {
    const country = Number(e.target.value)
    await this.props.change(this.getCityField().name, null)
    await this.props.change(this.getLocationField().name, null)
    await this.loadCitiesToState(country)
  }

  loadCitiesToState = async country => {
    this.setState({
      isCitiesLoading: true,
      cities: [],
      locations: [],
      isLocationsLoading: true
    })
    const citiesApi = new CitiesApi()

    const citiesWithinRegions = await citiesApi.getCitiesByCountryWithinRegions(country)
    const preparedCities = this.prepareCities(citiesWithinRegions)

    this.setState({ cities: preparedCities, isCitiesLoading: false })
  }

  prepareCities = (citiesWithinRegions = []) => citiesWithinRegions.map(region => ({
    id: region.id,
    label: region.label,
    value: `region-${region.id}`,
    isGrouped: true,
    options: region.cities.map(city => ({
      id: city.id,
      label: city.label,
      value: city.value,
      region: region.id
    }))
  }))

  onCityChange = async e => {
    const city = Number(e.target.value)
    await this.props.change(this.getLocationField().name, null)
    await this.loadLocationsToState(city)
  }

  loadLocationsToState = async city => {
    await this.setState({...this.state, isLocationsLoading: true})
    const api = new LocationsApi()
    const locations = await api.getLocationsByCity(Number(city))
    this.setState({
      ...this.state,
      locations: this.prepareLocations(locations),
      isLocationsLoading: !locations.length
    })
  }

  prepareLocations = (locations = []) => locations.map(({id, label}) => ({id, label, value: id}))

  onSubmit = values => {
    if (!this.props.isLoading) {
      this.props.setLoading(true)
      const deniedKeys = ['userId', 'token', 'types']
      const searchFieldName = this.getSearchField().name
      const isNeedToResetFilterValues = this.props.lastChangedField === searchFieldName
      const notEmptyValues = {}

      let hrefQuery = {...Router.query}

      for (let key in values) {
        if (values.hasOwnProperty(key) && !deniedKeys.includes(key)) {
          if (values[key]) {
            if (isNeedToResetFilterValues) {
              if (key === searchFieldName) notEmptyValues[key] = values[key]
              else delete hrefQuery[key]
            } else {
              if (key !== searchFieldName) notEmptyValues[key] = values[key]
              else delete hrefQuery[key]
            }
          } else {
            if (hrefQuery.hasOwnProperty(key)) delete hrefQuery[key]
          }
        }
      }

      hrefQuery = {...hrefQuery, ...notEmptyValues}

      const {...asValues} = notEmptyValues
      const asQuery = isNeedToResetFilterValues ? {[searchFieldName]: values[searchFieldName]} : asValues
      const href = {pathname: Router.route, query: hrefQuery}
      const as = {pathname: this.props.baseAs, query: asQuery}

      Router.push(href, as)
    }
  }

  isServiceProvider = () => this.props.userType && this.props.userType.seo === config.userTypes.serviceProviderSeo

  getServicesField = () => {
    const { services } = this.props
    return {
      id: 'service',
      labelDefault: 'Izaberi djelatnost',
      name: 'service',
      onChange: this.onServiceChange,
      options: Array.isArray(services) ? services.map(serviceGroup => {
        return {
          id: `service-${serviceGroup.group}`,
          label: serviceGroup.group,
          isGrouped: true,
          isDisabled: false,
          options: serviceGroup.services.map(item => ({
            value: item.id,
            isDisabled: false,
            label: item.name
          }))
        }
      }) : null,
      needColon: false,
      className: 'users-list__select'
    }
  }

  getServiceTypesField = () => ({
    id: 'serviceType',
    labelDefault: 'Izaberi tip usluge',
    name: 'serviceType',
    disabled: this.state.isServiceTypesLoading,
    options: this.state.serviceTypes,
    needColon: false,
    className: 'users-list__select'
  })

  prepareServiceTypes = (serviceTypes = []) => serviceTypes.map(({id, name}) => ({id, label: name, value: id}))

  onServiceChange = async e => {
    const service = Number(e.target.value)
    await this.props.change(this.getServiceTypesField().name, null)
    await this.loadServiceTypesToState(service)
  }

  loadServiceTypesToState = async service => {
    if (service) {
      await this.setState({...this.state, isServiceTypesLoading: true})
      const api = new ServiceTypesApi()
      const serviceTypes = await api.fetchServiceTypesByService(service)
      await this.setState({
        ...this.state,
        serviceTypes: this.prepareServiceTypes(serviceTypes),
        isServiceTypesLoading: !serviceTypes.length
      })
    }
  }

  renderFilterFields = () => {
    const { userType, jobFieldSpecification } = this.props

    switch (userType.seo) {
      case config.userTypes.serviceProviderSeo:
        return (
          <React.Fragment>
            <Select {...this.getServicesField()} />
            <Select {...this.getServiceTypesField()} />
          </React.Fragment>
        )
      case 'web-prodavnica':
        return <Select {...this.getCategoryField()} />
      case 'auto-moto-nautika':
        return <Select {...this.getUserTypeField()} />
      case 'nekretnine':
        return <Select {...this.getUserTypeField()} />
      case 'poslodavac':
        return jobFieldSpecification ? <Select {...this.getJobField()} /> : null
      default: return null
    }
  }

  render () {
    return (
      <Form className='pretraga-prodavnica-form' onSubmit={this.props.handleSubmit(this.onSubmit)}>
        <div className='users-list__filter-row'>
          {this.renderFilterFields()}
          <TextInput {...this.getSearchField()} />
          <button type='submit'><i className='ico-pretraga-text-search-lupa ico' /></button>
        </div>
        <div className='users__filter-row'>
          <Select {...this.getCountryField()} />
          <Select {...this.getCityField()} />
          <Select {...this.getLocationField()} />
        </div>
      </Form>
    )
  }
}

const mapStateToProps = state => {
  const query = getQuery(state)
  const userType = getUserType(state)
  const jobFieldSpecification = getJobFieldSpecification(state)

  const initialValues = query ? Object.keys(query).reduce((acc, curr) => {
    if (curr === 'specifications' && typeof query[curr] === 'object') {
      const specifications = query[curr].filter(spec => {
        return !jobFieldSpecification || spec.id === jobFieldSpecification.specification.id
      })

      acc[curr] = JSON.stringify(specifications)
    } else {
      acc[curr] = query[curr]
    }

    return acc
  }, {}) : {}

  return {
    categories: getCategories(state),
    countries: getCountries(state),
    cities: getCitiesByCountryWithinRegions(state),
    locations: getLocations(state),
    initialValues,
    isLoading: getLoading(state),
    userType,
    services: getServices(state),
    serviceTypes: getServiceTypes(state),
    lastChangedField: getLastChangedField(state),
    jobFieldSpecification
  }
}

export default compose(
  connect(mapStateToProps, {change, setQuery, setLastChangedField, setLoading}),
  reduxForm({
    form: FilterForm.formName,
    enableReinitialize: true,
    onChange: (values, dispatch, props, previousValues) => {
      for (let key in values) {
        if (values.hasOwnProperty(key)) {
          if (values[key] !== previousValues[key]) {
            dispatch(setLastChangedField(key))
          }
        }
      }
      if (values.fullText === previousValues.fullText && !props.isLoading) {
        setTimeout(() => {
          props.submit()
        }, 1)
      }
    }
  })
)(FilterForm)
